import { EventItem } from '@/components/common'
import { EventItemLoading } from '@/components/skeleton'
import { ROUTE_EVENTS } from '@/constants/Routes'
import { Event } from '@/types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type Props = {
  isLoadingEvents?: boolean
  isLoadingMyEvents?: boolean
  myEvents?: Event[]
  events?: Map<number, Event>
  hasMore?: boolean
  setLastElement?: any
  isMyEventEmpty?: boolean
}

export const EventContent = ({
  isLoadingEvents,
  isLoadingMyEvents,
  myEvents,
  events,
  hasMore,
  setLastElement,
  isMyEventEmpty,
}: Props) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const onNavigateMyEvents = () => {
    navigate(`${ROUTE_EVENTS}/my`)
  }

  const returnMyEvents = () => {
    if (isLoadingMyEvents)
      return (
        <>
          <EventItemLoading />
          <EventItemLoading />
        </>
      )

    if (myEvents) return myEvents?.map((item) => <EventItem key={item.leagueId} event={item} />)

    return <></>
  }

  return (
    <div className="mt-8">
      {!isMyEventEmpty && (
        <div className="flex flex-col gap-y-4">
          <div className="flex justify-between items-center">
            <h2 className="text-white font-semibold text-xl">{t('event.myEvents')}</h2>
            <button className="text-white text-sm font-semibold" onClick={onNavigateMyEvents}>
              {t('common.viewAll')}
            </button>
          </div>
          <div className="flex flex-col gap-y-2 w-full">{returnMyEvents()}</div>
        </div>
      )}

      <div className="mt-4">
        <h2 className="text-white font-semibold text-xl">{t('event.explore')}</h2>

        {events &&
          Array.from(events?.values())?.map((item, index) => (
            <div key={item.leagueId} ref={index === events?.size - 1 && hasMore ? setLastElement : null}>
              <EventItem className="mt-3" event={item} />
            </div>
          ))}
        {isLoadingEvents && (
          <>
            <EventItemLoading className="mt-3" />
            <EventItemLoading className="mt-3" />
            <EventItemLoading className="mt-3" />
            <EventItemLoading className="mt-3" />
            <EventItemLoading className="mt-3" />
          </>
        )}
        {!hasMore && (
          <div className="flex justify-center mt-4">
            <span className="text-white font-semibold text-opacity-60">{t('common.noMoreResults')}</span>
          </div>
        )}
      </div>
    </div>
  )
}
